<h2 mat-dialog-title>{{data?.title || '¡Esta accion es irreversible!'}}</h2>
<mat-dialog-content>{{data?.body || '¿Desea continuar?'}}</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" style="margin-right: 10px">No</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Si</button>
</div>
